function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.3333 7H11.6667C9.08934 7 7 9.08934 7 11.6667V44.3333C7 46.9107 9.08934 49 11.6667 49H44.3333C46.9107 49 49 46.9107 49 44.3333V11.6667C49 9.08934 46.9107 7 44.3333 7Z",
  stroke: "#A0A0A0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8333 23.3333C21.7662 23.3333 23.3333 21.7663 23.3333 19.8333C23.3333 17.9003 21.7662 16.3333 19.8333 16.3333C17.9003 16.3333 16.3333 17.9003 16.3333 19.8333C16.3333 21.7663 17.9003 23.3333 19.8333 23.3333Z",
  stroke: "#A0A0A0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M49.0001 35L37.3334 23.3333L11.6667 49",
  stroke: "#A0A0A0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgImage = function SvgImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image.04cb7c14.svg";
export { ForwardRef as ReactComponent };